<template>
  <div class="selectLoc_w bc_fff"  @click.stop>
    <div class="title fz18 c_4D4D4D">选择区域</div>
    <div>
      <ul class="list_w d_flex flex_wrap">
        <li :title="item.value" v-for="item in siteInfo.subsetRegions" :key="item.key" class="loc_label text_ellipsis  text_center " :class="!item.url?'dis_select':'allow_select'" @click.stop="onClickLoc(item)">{{ item.value }}</li>
      </ul>

      <div v-if="!locList || !locList.length" style="height:100%;margin-bottom:20px" class="x_y_center">
        <img src="@/assets/images/empty_icon.png" alt="">
        <span style="margin:0 0 0 10px" class="fz14">暂无数据</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'

export default {

  data() {
    return {
      locList: new Array(7)
    }
  },
  computed: {
    ...mapGetters(['siteInfo', 'userinfo'])
  },
  created() {
  },
  methods: {
    onClickLoc(item) {
      let token = Cookies.get('token')
      if (item.url) {
        window.open( token? `${item.url}/?token=${token}`:item.url, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.origin{
    transform: scale(0);
}
.dis_select{
  color: #B3B3B3;
  background: #F2F2F2;
  cursor: no-drop;
}
.allow_select{
  background-color: #F2F2F2;
  color:#4d4d4d;
  cursor: pointer;
}
.selectLoc_w{
    padding: 10px 10px 0 10px;
    .title{

    }
    .list_w{
        margin-top: 20px;
    }
    .loc_label{
        width: 90px;
        height: 40px;
        line-height: 40px;
        margin: 0 20px 20px 0;
        padding: 0 10px;
        box-sizing: border-box;
        &:nth-child(6n){
            margin-right: 0;
        }
    }
}
</style>
